import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/farm.png';
import _imports_1 from '@/assets/images/icons/enter.svg';
import _imports_2 from '@/assets/images/icons/new2.svg';
const _withScopeId = n => (_pushScopeId("data-v-9c249342"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "section-padding pt-0 horizontal-accordion bg-light-gray mt-4"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "28px",
    "height": "28px"
  },
  class: "mr-2",
  alt: ""
}, null, -1));
const _hoisted_4 = {
  class: "row mt-3"
};
const _hoisted_5 = {
  class: "col-xl-8 col-12 order-xl-0 order-1 mt-xl-0 mt-3"
};
const _hoisted_6 = {
  class: "d-flex flex-row mb-3 mt-1"
};
const _hoisted_7 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_9 = {
  class: "mt-3"
};
const _hoisted_10 = {
  class: "row d-flex align-items-center"
};
const _hoisted_11 = {
  class: "col-lg-3 col-sm-4 col-12 order-lg-1 order-2 mt-sm-0 mt-3"
};
const _hoisted_12 = {
  class: "col-lg-3 col-sm-4 col-12 mt-3 mt-sm-0 order-lg-2 order-3 farm-index"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-2 order-lg-2"
}, null, -1));
const _hoisted_14 = {
  class: "col-lg-4 col-sm-4 col-12 mt-3 mt-sm-0 order-lg-2 order-3 farm-index"
};
const _hoisted_15 = {
  class: "d-lg-block d-none"
};
const _hoisted_16 = {
  class: "d-flex row mt-4 align-items-center ml-1 mr-1 pt-2 pb-2 fs-12",
  style: {
    "border-top": "solid 1px #eeeeee",
    "border-bottom": "solid 1px #eeeeee",
    "color": "#787A9B"
  }
};
const _hoisted_17 = {
  style: {
    "width": "15%"
  },
  class: "text-center"
};
const _hoisted_18 = {
  class: "mr-1"
};
const _hoisted_19 = {
  class: "mr-1"
};
const _hoisted_20 = {
  class: "mr-1"
};
const _hoisted_21 = {
  class: "mr-1"
};
const _hoisted_22 = {
  "element-loading-text": "Loading...",
  style: {
    "min-height": "400px"
  }
};
const _hoisted_23 = ["onMouseenter", "onMouseleave", "onClick"];
const _hoisted_24 = {
  style: {
    "width": "16%",
    "padding-left": "25px"
  },
  class: "text-left d-flex align-content-center align-items-center"
};
const _hoisted_25 = {
  class: "position-relative"
};
const _hoisted_26 = {
  class: "fsi-18"
};
const _hoisted_27 = {
  class: "mr-1"
};
const _hoisted_28 = {
  style: {
    "width": "15%"
  },
  class: "text-right"
};
const _hoisted_29 = {
  style: {
    "width": "20%"
  },
  class: "text-right"
};
const _hoisted_30 = {
  style: {
    "width": "20%"
  },
  class: "text-right"
};
const _hoisted_31 = {
  style: {
    "width": "21%"
  },
  class: "text-right"
};
const _hoisted_32 = {
  style: {
    "width": "5%"
  }
};
const _hoisted_33 = {
  class: "text-right fs-12"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "25px"
  },
  alt: ""
}, null, -1));
const _hoisted_35 = [_hoisted_34];
const _hoisted_36 = {
  class: "d-block d-lg-none"
};
const _hoisted_37 = {
  "element-loading-text": "Loading...",
  style: {
    "min-height": "400px"
  }
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = {
  class: "col-12 justify-content-between d-flex align-content-center align-items-center"
};
const _hoisted_40 = {
  class: "mr-3"
};
const _hoisted_41 = {
  class: "d-flex align-items-center"
};
const _hoisted_42 = {
  key: 0,
  src: _imports_2,
  style: {
    "width": "32px",
    "margin-right": "5px",
    "transform": "translateY(-1px)"
  },
  alt: ""
};
const _hoisted_43 = {
  class: "col-12 justify-content-between d-flex align-content-center align-items-center mt-1"
};
const _hoisted_44 = {
  class: "mr-3"
};
const _hoisted_45 = {
  class: "col-12 justify-content-between d-flex align-content-center align-items-center mt-1"
};
const _hoisted_46 = {
  class: "mr-3"
};
const _hoisted_47 = {
  class: "col-12 justify-content-between d-flex align-content-center align-items-center mt-1"
};
const _hoisted_48 = {
  class: "mr-3"
};
const _hoisted_49 = {
  class: "col-12 justify-content-between d-flex align-content-center align-items-center mt-1"
};
const _hoisted_50 = {
  class: "mr-3"
};
const _hoisted_51 = {
  class: "col-12 justify-content-between d-flex align-content-center align-items-center mt-1"
};
const _hoisted_52 = {
  class: "mr-3"
};
const _hoisted_53 = {
  class: "col-12 text-left d-flex align-content-center align-items-center"
};
const _hoisted_54 = {
  class: "view-btn-mobe"
};
const _hoisted_55 = {
  class: "pl-4 pr-4 pt-3 pb-3 border-radius-20 dashboard-card"
};
const _hoisted_56 = {
  class: "d-flex flex-row mb-3 mt-1"
};
const _hoisted_57 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_59 = {
  class: "d-block d-sm-flex mb-4"
};
const _hoisted_60 = {
  class: "mr-md-5 mr-4"
};
const _hoisted_61 = {
  class: "fw-medium fsi-14 subheading-text"
};
const _hoisted_62 = {
  class: "fw-bold fsi-18"
};
const _hoisted_63 = {
  class: "fw-medium fsi-14"
};
const _hoisted_64 = {
  class: "fw-bold fsi-18"
};
const _hoisted_65 = {
  key: 0,
  class: "fw-medium fsi-14"
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-none d-sm-block vertical-dividing-line mr-4"
}, null, -1));
const _hoisted_67 = {
  class: "mr-5 mt-3 mt-sm-0"
};
const _hoisted_68 = {
  class: "fw-medium fsi-14 subheading-text"
};
const _hoisted_69 = {
  class: "fw-bold fsi-18"
};
const _hoisted_70 = {
  class: "fw-medium fsi-14"
};
const _hoisted_71 = {
  class: "fw-bold fsi-18"
};
const _hoisted_72 = {
  key: 0,
  class: "fw-medium fsi-14"
};
const _hoisted_73 = {
  class: "col-xl-4 col-12 order-xl-1 order-0"
};
const _hoisted_74 = {
  class: "d-flex flex-row mb-3 justify-content-between align-items-center"
};
const _hoisted_75 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_76 = {
  class: "mb-3"
};
const _hoisted_77 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_78 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_79 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_80 = {
  class: "fw-bold fsi-16"
};
const _hoisted_81 = {
  class: "flex-center copy-text"
};
const _hoisted_82 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_83 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_84 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_85 = {
  class: "fw-bold fsi-16"
};
const _hoisted_86 = {
  class: "flex-center copy-text"
};
const _hoisted_87 = {
  class: "fw-bold fsi-16 mr-1"
};
const _hoisted_88 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_89 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_90 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_91 = {
  class: "fw-bold fsi-14"
};
const _hoisted_92 = {
  class: "flex-center copy-text"
};
const _hoisted_93 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_94 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_95 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_96 = {
  class: "fw-bold fsi-16"
};
const _hoisted_97 = {
  class: "fw-bold fsi-16"
};
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-3"
}, null, -1));
const _hoisted_99 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_100 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_101 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_102 = ["innerHTML"];
const _hoisted_103 = {
  class: "fw-bold fsi-16"
};
const _hoisted_104 = {
  class: "fw-bold fsi-16"
};
const _hoisted_105 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_106 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_107 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_108 = ["innerHTML"];
const _hoisted_109 = {
  class: "fw-bold fsi-16"
};
const _hoisted_110 = {
  class: "fw-bold fsi-16"
};
const _hoisted_111 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_112 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_113 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_114 = {
  class: "fw-bold fsi-16"
};
const _hoisted_115 = {
  class: "fw-bold fsi-16"
};
const _hoisted_116 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_117 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_118 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_119 = ["innerHTML"];
const _hoisted_120 = {
  class: "fw-bold fsi-16"
};
const _hoisted_121 = {
  class: "fw-bold fsi-16"
};
const _hoisted_122 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_123 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_124 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_125 = ["innerHTML"];
const _hoisted_126 = {
  class: "fw-bold fsi-16"
};
const _hoisted_127 = {
  class: "fw-bold fsi-16"
};
const _hoisted_128 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-3"
}, null, -1));
const _hoisted_129 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_130 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_131 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_132 = {
  class: "fw-bold fsi-16"
};
const _hoisted_133 = {
  class: "fw-bold fsi-16"
};
const _hoisted_134 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_135 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_136 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_137 = {
  class: "fw-bold fsi-16"
};
const _hoisted_138 = {
  class: "fw-bold fsi-16"
};
const _hoisted_139 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_140 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_141 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_142 = ["innerHTML"];
const _hoisted_143 = {
  class: "fw-bold fsi-16"
};
const _hoisted_144 = {
  class: "fw-bold fsi-16"
};
const _hoisted_145 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_146 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_147 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_148 = {
  class: "fw-bold fsi-16"
};
const _hoisted_149 = {
  class: "fw-bold fsi-16"
};
const _hoisted_150 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_151 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_152 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_153 = ["innerHTML"];
const _hoisted_154 = {
  class: "fw-bold fsi-16"
};
const _hoisted_155 = {
  class: "fw-bold fsi-16"
};
const _hoisted_156 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-3"
}, null, -1));
const _hoisted_157 = {
  key: 0,
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_158 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_159 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_160 = {
  class: "fw-bold fsi-16"
};
const _hoisted_161 = {
  class: "fw-bold fsi-14"
};
const _hoisted_162 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_163 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_164 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_165 = ["innerHTML"];
const _hoisted_166 = ["innerHTML"];
const _hoisted_167 = {
  class: "fw-bold fsi-16"
};
const _hoisted_168 = {
  class: "fw-bold fsi-16"
};
const _hoisted_169 = {
  class: "d-flex justify-content-between mb-3"
};
const _hoisted_170 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_171 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_172 = ["innerHTML"];
const _hoisted_173 = {
  class: "fw-bold fsi-16"
};
const _hoisted_174 = {
  class: "fw-bold fsi-16"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_page_head = _resolveComponent("page-head");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Sort = _resolveComponent("Sort");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_ScrollNumber = _resolveComponent("ScrollNumber");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_chart_block = _resolveComponent("chart-block");
  const _component_CopyDocument = _resolveComponent("CopyDocument");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_Edit = _resolveComponent("Edit");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_page_head, {
    showReturn: true,
    backPath: "/farm"
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('subpool.poolInfoTitle')), 1)]),
    icon: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: _normalizeClass(["dashboard-card border-radius-20 pt-3 pb-3 mb-3", _ctx.isMini ? 'pl-2 pr-2' : 'pl-4 pr-4'])
  }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('farm.StorageProviders')), 1), _hoisted_8]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_input, {
    modelValue: $data.serch.data,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.serch.data = $event),
    onInput: $options.changeSearch,
    size: $options.isMobile() ? 'large' : 'default',
    placeholder: _ctx.$t('farm.Search'),
    "suffix-icon": $data.Search
  }, null, 8, ["modelValue", "onInput", "size", "placeholder", "suffix-icon"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_select, {
    modelValue: $data.nodeType,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.nodeType = $event),
    "input-style": "height: 50px;",
    placeholder: "Select",
    size: $options.isMobile() ? 'large' : 'default'
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nodeTypeOptions, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "size"])]), _hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-sm-button",
    onClick: $options.onboarding,
    style: {
      "border-radius": "10px !important",
      "padding": "21px 20px !important"
    },
    loading: $data.initCurrentPoolInfoLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.title')), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('farm.Node')), 1), _createElementVNode("div", {
    style: {
      "width": "15%"
    },
    class: "flex-center justify-content-end cursor-pointer",
    onClick: _cache[2] || (_cache[2] = $event => $options.sortFixed('quality_adj_power'))
  }, [_createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('farm.power')), 1), _createVNode(_component_Sort, {
    type: $data.fixedSortType['quality_adj_power']
  }, null, 8, ["type"])]), _createElementVNode("div", {
    style: {
      "width": "20%"
    },
    class: "flex-center justify-content-end cursor-pointer",
    onClick: _cache[3] || (_cache[3] = $event => $options.sortFixed('availableBalance'))
  }, [_createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('farm.console.AvailableBalance')), 1), _createVNode(_component_Sort, {
    type: $data.fixedSortType['availableBalance']
  }, null, 8, ["type"])]), _createElementVNode("div", {
    style: {
      "width": "20%"
    },
    class: "flex-center justify-content-end cursor-pointer",
    onClick: _cache[4] || (_cache[4] = $event => $options.sortFixed('debt_value'))
  }, [_createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('farm.Debt')), 1), _createVNode(_component_Sort, {
    type: $data.fixedSortType['debt_value']
  }, null, 8, ["type"])]), _createElementVNode("div", {
    style: {
      "width": "21%"
    },
    class: "flex-center justify-content-end cursor-pointer",
    onClick: _cache[5] || (_cache[5] = $event => $options.sortFixed('entity_value'))
  }, [_createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('farm.Equity')), 1), _createVNode(_component_Sort, {
    type: $data.fixedSortType['entity_value']
  }, null, 8, ["type"])])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nodesTemplateData, (node, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onMouseenter: $event => $options.handleEnter([node.node]),
      onMouseleave: $event => $options.handleLeave([node.node]),
      class: "sp-row-line row fsi-16",
      onClick: $event => $options.showView(node)
    }, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString($options.getPrefix()) + _toDisplayString(node.node), 1)])])]), _createElementVNode("div", _hoisted_28, _toDisplayString($options.formatBit(node.quality_adj_power)), 1), _createElementVNode("div", _hoisted_29, _toDisplayString($options.formatWalletFilPrice(node.availableBalance, 2, false, false)), 1), _createElementVNode("div", _hoisted_30, _toDisplayString($options.formatWalletFilPrice(node.debt_value, 2, false, false)), 1), _createElementVNode("div", _hoisted_31, _toDisplayString($options.formatWalletFilPrice(node.entity_value, 2, false, false)), 1), _createElementVNode("div", _hoisted_32, [_withDirectives(_createElementVNode("div", _hoisted_33, _hoisted_35, 512), [[_vShow, $data.showViewBtn[node.node] === true]])])], 40, _hoisted_23);
  }), 128))])), [[_directive_loading, $data.loading]])]), _createElementVNode("div", _hoisted_36, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nodesTemplateData, (node, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", {
      class: "sp-row-line row fsi-14",
      onClick: $event => $options.showView(node)
    }, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('farm.Node')), 1), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_41, [$options.isNew(node) ? (_openBlock(), _createElementBlock("img", _hoisted_42)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($options.getPrefix()) + _toDisplayString(node.node), 1)])])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('farm.power')), 1), _createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString($options.formatBit(node.quality_adj_power)), 1)])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('farm.console.AvailableBalance')), 1), _createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString($options.formatWalletFilPrice(node.availableBalance, 2, false, false)), 1)])]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('farm.Equity')), 1), _createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString($options.formatWalletFilPrice(node.entity_value, 2, false, false)), 1)])]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('farm.Debt')), 1), _createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString($options.formatWalletFilPrice(node.debt_value, 2, false, false)), 1)])]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('farm.console.InterestValue')), 1), _createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString($options._formatWalletFilPriceInterest(node.interestBigInt)), 1)])]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('farm.View')), 1)])], 8, _hoisted_38)]);
  }), 128))])), [[_directive_loading, $data.loading]])])])], 2), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('dashboard.BorrowInfo')), 1), _hoisted_58]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('dashboard.Variable')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.variableDebtTokenTotalSupplyLoading && !_ctx.timingFlag,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_62, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "120px"
      }
    })]), _createElementVNode("div", _hoisted_63, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "120px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_64, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "FIL",
      number: $options.formatWalletFilPrice(_ctx.variableDebtTokenTotalSupply, 2, true, true, false),
      h: 18
    }, null, 8, ["number"])]), _ctx.variableDebtTokenTotalSupplyObj !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_createVNode(_component_ScrollNumber, {
      prefix: "$",
      class: "scroll-number-sub-title",
      customSignStyle: {
        margin: '0 -3.5px !important'
      },
      "prefix-style": {
        margin: '0'
      },
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0'
      },
      color: "",
      unit: _ctx.variableDebtTokenTotalSupplyObj.suffix,
      number: _ctx.variableDebtTokenTotalSupplyObj.value,
      h: 14
    }, null, 8, ["customSignStyle", "unit", "number"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])]), _hoisted_66, _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('dashboard.Stable')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.stableDebtTokenTotalSupplyLoading && !_ctx.timingFlag,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_69, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "120px"
      }
    })]), _createElementVNode("div", _hoisted_70, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "120px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_71, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "FIL",
      number: $options.formatWalletFilPrice(_ctx.stableDebtTokenTotalSupply, 2, true, true, false),
      h: 18
    }, null, 8, ["number"])]), _ctx.stableDebtTokenTotalSupplyObj !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_72, [_createVNode(_component_ScrollNumber, {
      prefix: "$",
      class: "scroll-number-sub-title",
      customSignStyle: {
        margin: '0 -3.5px !important'
      },
      "prefix-style": {
        margin: '0'
      },
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0'
      },
      color: "",
      unit: _ctx.stableDebtTokenTotalSupplyObj.suffix,
      number: _ctx.stableDebtTokenTotalSupplyObj.value,
      h: 14
    }, null, 8, ["customSignStyle", "unit", "number"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])]), _createVNode(_component_chart_block, {
    ref: "chartBorrow",
    height: "350px",
    option: $data.optionBorrowInfo,
    onChartSelect: $options.chartBorrowSelect
  }, null, 8, ["option", "onChartSelect"])])]), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", {
    class: _normalizeClass(["dashboard-card border-radius-20 pt-3 pb-5", _ctx.isSuperMini ? 'pl-3 pr-3' : 'pl-4 pr-4'])
  }, [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t('common.Overview')), 1)]), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.$t('subpool.poolInfoTip.poolAddress')), 1)]), _createVNode(_component_i_skeleton, {
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_80, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", {
      class: "fw-bold fsi-14 mr-1 link-text-ordinary",
      onClick: _cache[6] || (_cache[6] = $event => $options.gotoAddress($data.poolAddress, _ctx.$i18n.locale))
    }, _toDisplayString($options.simpleValue($data.poolAddress, 6, 6)), 1), _createVNode(_component_el_icon, {
      class: "cursor-pointer icon-hover",
      onClick: _cache[7] || (_cache[7] = $event => $options.copyAddress($data.poolAddress))
    }, {
      default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
      _: 1
    })])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$t('subpool.poolType')), 1)]), _createVNode(_component_i_skeleton, {
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_85, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.$t('subpool.Storage Provider')), 1)])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.$t('subpool.adminAddress')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('subpool.poolInfoTip.poolAdmin')), 1)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_91, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_92, [_createElementVNode("div", {
      class: "fw-bold fsi-14 mr-1 link-text-ordinary",
      onClick: _cache[8] || (_cache[8] = $event => $options.gotoAddress(_ctx.poolAdmin, _ctx.$i18n.locale))
    }, [_createElementVNode("span", null, _toDisplayString($options.simpleValue(_ctx.poolAdmin, 6, 6)), 1)]), _createVNode(_component_el_icon, {
      class: "cursor-pointer icon-hover",
      onClick: _cache[9] || (_cache[9] = $event => $options.copyAddress(_ctx.poolAdmin))
    }, {
      default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
      _: 1
    }), _createVNode(_component_el_icon, {
      class: "cursor-pointer ml-1 icon-hover",
      onClick: $options.transferOwnership
    }, {
      default: _withCtx(() => [_createVNode(_component_Edit)]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.$t('subpool.nodeCount')), 1)]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_96, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.poolNodeCount) + " / 20 ", 1)]),
    _: 1
  }, 8, ["loading"])]), _hoisted_98, _createElementVNode("div", _hoisted_99, [_createElementVNode("div", _hoisted_100, [_createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.$t('subpool.poolEquity')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('subpool.poolInfoTip.equity')
    }, null, 8, _hoisted_102)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_103, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_104, _toDisplayString($options.formatWalletFilPrice(_ctx.poolEquityValue)), 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_105, [_createElementVNode("div", _hoisted_106, [_createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.$t('subpool.poolDebt')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('subpool.poolInfoTip.debt')
    }, null, 8, _hoisted_108)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_109, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_110, _toDisplayString($options.formatWalletFilPrice(_ctx.poolTotalDebt)), 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_111, [_createElementVNode("div", _hoisted_112, [_createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.$t('subpool.poolSealLoadTotalAmount')), 1)]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_114, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_115, _toDisplayString($options.formatWalletFilPrice(_ctx.poolSeadLoadTotalAmount)), 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_116, [_createElementVNode("div", _hoisted_117, [_createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.$t('subpool.poolWithdrawLoadTotalAmount')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('subpool.poolInfoTip.borrowLoan')
    }, null, 8, _hoisted_119)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_120, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_121, _toDisplayString($options.formatWalletFilPrice(_ctx.poolWithdrawLoadTotalAmount)), 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_122, [_createElementVNode("div", _hoisted_123, [_createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.$t('subpool.poolPosition')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('subpool.poolInfoTip.position')
    }, null, 8, _hoisted_125)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_126, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_127, _toDisplayString($options.formatWalletFilPrice(_ctx.poolPosition)), 1)])]),
    _: 1
  }, 8, ["loading"])]), _hoisted_128, _createElementVNode("div", _hoisted_129, [_createElementVNode("div", _hoisted_130, [_createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.$t('subpool.Available Seal Load')), 1)]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_132, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_133, _toDisplayString($options.formatWalletFilPrice(_ctx.poolAvailableSealLoad)), 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_134, [_createElementVNode("div", _hoisted_135, [_createElementVNode("span", _hoisted_136, _toDisplayString(_ctx.$t('subpool.Available Withdrawal Loan')), 1)]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_137, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_138, _toDisplayString($options.formatWalletFilPrice(_ctx.poolAvailableWithdrawalLoan)), 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_139, [_createElementVNode("div", _hoisted_140, [_createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.$t('subpool.DebtRatio')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('subpool.poolInfoTip.debtRate')
    }, null, 8, _hoisted_142)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_143, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_144, _toDisplayString($options.formatUnits(_ctx.poolDebtRatio, 2)) + "% ", 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_145, [_createElementVNode("div", _hoisted_146, [_createElementVNode("span", _hoisted_147, _toDisplayString(_ctx.$t('subpool.MaximumDebtRatio')), 1)]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_148, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_149, _toDisplayString($options.formatUnits(_ctx.poolMaxDebtRatio, 2)) + "%", 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_150, [_createElementVNode("div", _hoisted_151, [_createElementVNode("span", _hoisted_152, _toDisplayString(_ctx.$t('subpool.LiqThreshold')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('subpool.poolInfoTip.litRate')
    }, null, 8, _hoisted_153)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_154, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_155, _toDisplayString($options.formatUnits(_ctx.poolLiquidationThreshold, 2)) + "% ", 1)]),
    _: 1
  }, 8, ["loading"])]), _hoisted_156, _ctx.poolOnlyAcceptsNewNodes ? (_openBlock(), _createElementBlock("div", _hoisted_157, [_createElementVNode("div", _hoisted_158, [_createElementVNode("span", _hoisted_159, _toDisplayString(_ctx.$t('subpool.Entry requirement')), 1)]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_160, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_161, _toDisplayString(_ctx.poolOnlyAcceptsNewNodes ? _ctx.$t('subpool.The node balance is less than') : _ctx.$t('subpool.none')), 1)]),
    _: 1
  }, 8, ["loading"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_162, [_createElementVNode("div", _hoisted_163, [_createElementVNode("span", _hoisted_164, _toDisplayString(_ctx.$t('subpool.MaxSealLoadLeverage')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [!_ctx.poolOnlyAcceptsNewNodes ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      innerHTML: _ctx.$t('subpool.poolInfoTip.withLoan')
    }, null, 8, _hoisted_165)) : _createCommentVNode("", true), _ctx.poolOnlyAcceptsNewNodes ? (_openBlock(), _createElementBlock("span", {
      key: 1,
      innerHTML: _ctx.$t('subpool.poolInfoTip.withLoan2')
    }, null, 8, _hoisted_166)) : _createCommentVNode("", true)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_167, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_168, _toDisplayString($options.formatUnits(_ctx.maxSealLoadLeverage, 4)) + "x", 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_169, [_createElementVNode("div", _hoisted_170, [_createElementVNode("span", _hoisted_171, _toDisplayString(_ctx.$t('subpool.poolMaxWithdrawLoadLeverage')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('subpool.poolInfoTip.borrowLoanLeverage')
    }, null, 8, _hoisted_172)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: $data.initCurrentPoolInfoLoading,
    style: {
      "max-width": "40%"
    }
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_173, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_174, _toDisplayString($options.formatUnits(_ctx.poolMaxWithdrawLoadLeverage, 4)) + "x ", 1)]),
    _: 1
  }, 8, ["loading"])])])], 2)])])])]);
}